import { ActionType, Action, carrierSearch } from "../actions/types"

const initialCarrierSearch: carrierSearch = {
  carrierDetails: [
    {
      id: "",
      name: "",
      permalink: "",
      logo: "",
      type: "",
      status: {
        data: "",
        network: ""
      },
      contact: {
        name: "",
        phone: "",
        email: ""
      },
      address: {
        city: "",
        state: "",
        stateCode: "",
        country: "",
        countryCode: ""
      },
      identifiers: [
        {
          type: "",
          value: ""
        }
      ],
      identifications: [
        {
          type: "",
          value: ""
        }
      ]
    }
  ]
}

const carrierSearchReducer = (
  state: carrierSearch = initialCarrierSearch,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_CARRIER_SEARCH:
      return {
        ...state,
        carrierDetails: action.payload.carrierDetails
      }
    default:
      return state
  }
}

export default carrierSearchReducer
